import React from 'react';
import { isNullOrUndefined } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';

interface ComponentProps {
  date?: string;
  time?: string;
  selected?: boolean;
  isWholeDay: boolean;
  timezoneId?: string;
  dataTestId?: string
}

const TimeListItem: React.FC<ComponentProps> = ({ date, time, selected, isWholeDay, timezoneId, dataTestId }) => {
  const { t } = useTranslation('common');
  return (
    <div>
    <div className="time-item" data-testid={`${dataTestId}-timeslot`}>
      {!isNullOrUndefined(selected) && (
        <>
          {selected === true && <i className="p-mr-2 pi pi-check"></i>}
          {selected === false && <i className="p-mr-2 pi pi-times"></i>}
        </>
      )}

      <span className="p-mr-4">{date}</span>
      <span>{isWholeDay ? t('TimeListItem.isWholeDay') : time}</span>
    </div>
      <COTimezone dataTestId={`${dataTestId}-timezone`} timezoneId={timezoneId} />
    </div>
  );
};
export default TimeListItem;
